/* Primo Europa: lógica de comparadores saneada, sin testimonios no verificables. */
(function () {
  const css = `
    /* ====== HEADER NATIVO DE GHOST: LOGO GRANDE + BANDERAS VISIBLES — v26 fix ====== */
    .gh-head, header.gh-head, header.site-header {
      position: relative !important;
      height: auto !important;
      min-height: unset !important;
      padding-top: 16px !important;
      padding-bottom: 16px !important;
      background-color: transparent !important;
      overflow: visible !important;
    }
    .gh-head::before, header.gh-head::before, header.site-header::before {
      content: "🇪🇸 🇲🇽 🇦🇷 🇨🇴 🇵🇪 🇨🇱 🇻🇪 🇪🇨 🇬🇹 🇨🇺 🇧🇴 🇩🇴 🇪🇸 🇲🇽 🇦🇷 🇨🇴 🇵🇪 🇨🇱";
      position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(-6deg);
      white-space: nowrap; font-size: 64px; line-height: 1.4;
      opacity: 0.07; filter: grayscale(100%); pointer-events: none; z-index: 0;
    }
    .gh-head::after, header.gh-head::after, header.site-header::after {
      content: ""; position: absolute; inset: 0; background-color: #F8FAFC; opacity: 0.92; z-index: 1;
    }

    /* Contenedor flex principal del header: logo | (trust badge) | acciones, todo centrado en Y */
    .gh-head-inner, .gh-head .gh-head-inner {
      position: relative !important;
      z-index: 2 !important;
      height: auto !important;
      display: flex !important;
      align-items: center !important;
      overflow: visible !important;
    }

    .gh-head-actions {
      display: flex !important;
      align-items: center !important;
      flex-shrink: 0 !important;
    }

    /* ====== TRUST BADGE PREMIUM JUNTO AL LOGO — v23 ====== */
    .primo-trust-badge {
      display: flex; align-items: center; gap: 10px;
      margin-left: 24px; padding-left: 24px;
      border-left: 2px solid #E2E8F0;
      flex-shrink: 0;
      z-index: 10;
    }
    .ptb-number {
      font-family: 'Fraunces', serif; font-size: 34px; font-weight: 900; line-height: 1;
      background: linear-gradient(135deg, #FF5A5F, #E14549);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    .ptb-text { display: flex; flex-direction: column; justify-content: center; }
    .ptb-text span {
      font-family: 'IBM Plex Sans', sans-serif; font-size: 11px; font-weight: 700;
      text-transform: uppercase; letter-spacing: 0.08em; color: #64748B; line-height: 1.3;
    }
    .ptb-text .ptb-highlight { color: #0F172A; }
    @media (max-width: 920px) { .primo-trust-badge { display: none; } }

    /* ====== HERO — v24 "Fintech Premium" (fondo más profundo + glow) ====== */
    #primo-hero { position: relative; overflow: hidden; background: radial-gradient(120% 160% at 15% 0%, #0A192F 0%, #060F1D 60%, #050C18 100%); padding: 40px 20px 56px; text-align: center; }
    #primo-hero::before {
      content: "🇪🇸 🇲🇽 🇦🇷 🇨🇴 🇵🇪 🇨🇱 🇻🇪 🇪🇨 🇬🇹 🇨🇺 🇧🇴 🇩🇴 🇪🇸 🇲🇽 🇦🇷 🇨🇴 🇵🇪 🇨🇱";
      position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(-8deg);
      white-space: nowrap; font-size: 120px; line-height: 1.4;
      opacity: 0.05; filter: grayscale(100%); pointer-events: none; z-index: 0;
    }
    #primo-hero::after {
      content: "";
      position: absolute; inset: -10%; z-index: 0; pointer-events: none;
      background:
        radial-gradient(38% 55% at 20% 15%, rgba(255,90,95,.22) 0%, rgba(255,90,95,0) 70%),
        radial-gradient(45% 60% at 85% 90%, rgba(26,46,74,.55) 0%, rgba(26,46,74,0) 70%);
      filter: blur(60px);
    }
    #primo-hero .primo-hero-inner { position: relative; z-index: 1; max-width: 780px; margin: 0 auto; }
    #primo-hero h1 { font-family: 'IBM Plex Sans', sans-serif; color: #fff; font-weight: 800; font-size: clamp(23px, 3.4vw, 34px); line-height: 1.16; margin: 0 0 8px; letter-spacing: -0.02em; }
    #primo-hero h1 em { display: block; font-style: normal; color: #FF5A5F; font-size: clamp(15px, 1.9vw, 20px); font-weight: 700; margin-top: 4px; }
    #primo-hero p.primo-sub { font-family: 'IBM Plex Sans', sans-serif; font-size: 14.5px; line-height: 1.45; color: rgba(255,255,255,.78); max-width: 560px; margin: 0 auto; }

    /* ====== INTERFAZ PRINCIPAL UNIFICADA (timeline sticky + interacción) ====== */
    #primo-main-interface { position: relative; z-index: 3; background: #F8FAFC; padding: 34px 20px 30px; }
    #primo-main-interface.primo-mi-overlap { margin-top: -24px; padding-top: 40px; border-radius: 22px 22px 0 0; box-shadow: 0 -14px 30px rgba(15,23,42,.06); }
    .primo-mi-inner {
      max-width: 980px; margin: 0 auto;
      display: flex; align-items: flex-start; gap: 28px;
    }

    .primo-mi-timeline {
      flex: 0 0 84px; position: sticky; top: 40px; align-self: flex-start;
      display: flex; flex-direction: column; align-items: center;
      padding-top: 4px; z-index: 2;
    }
    .primo-mi-timeline::before {
      content: ""; position: absolute; top: 22px; bottom: 22px; left: 50%; transform: translateX(-50%);
      width: 2px; background: repeating-linear-gradient(180deg, #E2E8F0 0 8px, transparent 8px 16px); z-index: 0;
    }
    .primo-mi-timeline-item {
      position: relative; z-index: 1;
      display: flex; flex-direction: column; align-items: center; text-align: center;
      margin-bottom: 64px;
    }
    .primo-mi-timeline-item:last-child { margin-bottom: 0; }
    .primo-mi-number {
      width: 44px; height: 44px; border-radius: 50%; flex: 0 0 auto;
      background: #0F172A; color: #fff; font-family: 'IBM Plex Sans', sans-serif; font-weight: 800; font-size: 17px;
      display: flex; align-items: center; justify-content: center; margin-bottom: 8px;
    }
    .primo-mi-label {
      font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 11.5px; color: #0F172A;
      line-height: 1.25; max-width: 76px;
    }

    .primo-mi-content { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 40px; }
    .primo-mi-hint {
      font-family: 'IBM Plex Sans', sans-serif; font-size: 13px; line-height: 1.5; color: #64748B;
      background: #fff; border: 1px dashed #E2E8F0; border-radius: 12px; padding: 14px 16px; margin: 0;
    }

    @media (max-width: 780px) {
      .primo-mi-inner { flex-direction: column; gap: 22px; }
      .primo-mi-timeline {
        position: static; flex: 1 1 auto; flex-direction: row; justify-content: space-between;
        width: 100%; padding: 0 6px;
      }
      .primo-mi-timeline::before {
        top: 50%; bottom: auto; left: 22px; right: 22px; transform: translateY(-50%);
        width: auto; height: 2px;
      }
      .primo-mi-timeline-item { flex: 1 1 0; margin-bottom: 0; }
      .primo-mi-content { gap: 26px; }
    }

    /* ====== BLOQUE DE MISIÓN (solo Home) — v22 ====== */
    .primo-mission-block { text-align: center; margin-bottom: 32px; }
    .primo-mission-block h3 { font-family: 'IBM Plex Sans', sans-serif; font-size: 20px; font-weight: 800; color: #0F172A; margin: 0 0 8px; }
    .primo-mission-block p { font-family: 'IBM Plex Sans', sans-serif; font-size: 14.5px; line-height: 1.5; color: #64748B; margin: 0; }

    /* ====== SELECTOR DE PAÍS ====== */
    .primo-country-card-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
    .primo-country-card {
      cursor: pointer; border-radius: 14px; border: 2px solid #E2E8F0; background: #fff;
      padding: 20px 16px; font-family: 'IBM Plex Sans', sans-serif;
      display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 12px;
      box-shadow: 0 4px 20px rgba(15,23,42,.03);
      transition: border-color .18s ease, box-shadow .25s ease, transform .25s ease, background .18s ease;
    }
    .primo-country-card .flag {
      display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto;
    }
    .flag-img {
      width: 32px; height: auto; border-radius: 3px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      display: block;
    }
    .primo-country-card .primo-country-card-text {
      font-size: 18px; font-weight: 800; color: #0F172A; line-height: 1;
    }
    .primo-country-card:hover { transform: translateY(-4px); box-shadow: 0 20px 40px rgba(15,23,42,.08); border-color: #FFC9C6; }
    .primo-country-card.primo-active {
      border-color: #FF5A5F; background: rgba(255,90,95,.06); box-shadow: 0 10px 26px rgba(255,90,95,.16);
    }

    /* ====== COLLAGE DE BANDERAS EN EL HEADER: inyectado en body, a prueba de overflow — v23 ====== */
    #primo-header-flags {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 9999;
      display: flex;
      gap: 8px;
      align-items: center;
      width: max-content;
      user-select: none;
    }
    .header-flag-img {
      width: 64px;
      min-width: 64px;
      flex-shrink: 0;
      height: auto;
      border-radius: 2px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.12);
      display: block;
      transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease;
    }
    #primo-header-flags .header-flag-img:hover {
      transform: scale(1.15) translateY(-3px);
      box-shadow: 0 6px 12px rgba(0,0,0,0.15);
    }
    @media (max-width: 920px) { #primo-header-flags { display: none; } }

    /* ====== CONTADOR DE IMPACTO ====== */
    #primo-impact { background: #F8FAFC; padding: 4px 20px 6px; }
    .primo-impact-inner {
      max-width: 620px; margin: 0 auto; display: flex; align-items: center; justify-content: center; gap: 14px;
      background: #fff; border: 1px solid #E2E8F0; border-radius: 40px; padding: 14px 26px; box-shadow: 0 4px 20px rgba(15,23,42,.05);
    }
    .primo-impact-icon {
      width: 36px; height: 36px; border-radius: 50%; background: rgba(255,90,95,.12); color: #FF5A5F; flex: 0 0 auto;
      display: flex; align-items: center; justify-content: center; font-size: 18px;
    }
    .primo-impact-text { font-family: 'IBM Plex Sans', sans-serif; font-size: 13.5px; font-weight: 600; color: #0F172A; line-height: 1.35; text-align: left; }
    .primo-impact-text b { color: #FF5A5F; }

    /* ====== ACORDEÓN DE FASES ====== */
    .primo-accordion { display: flex; flex-direction: column; gap: 12px; }
    .primo-accordion-item {
      background: #FFFFFF; border-radius: 14px; box-shadow: 0 4px 20px rgba(15,23,42,.05);
      overflow: hidden; transition: box-shadow .25s ease;
    }
    .primo-accordion-item:hover { box-shadow: 0 10px 34px rgba(15,23,42,.10); }
    .primo-accordion-item.primo-open { box-shadow: 0 10px 34px rgba(15,23,42,.12); }
    .primo-accordion-head {
      display: flex; align-items: center; justify-content: space-between;
      padding: 16px 18px; cursor: pointer; -webkit-tap-highlight-color: transparent;
    }
    .primo-accordion-title-wrap { display: flex; align-items: center; gap: 12px; }
    .primo-accordion-icon {
      width: 40px; height: 40px; border-radius: 50%; background: #F8FAFC; flex: 0 0 auto;
      display: flex; align-items: center; justify-content: center; font-size: 19px;
      transition: background .2s ease, box-shadow .2s ease;
    }
    .primo-accordion-item:hover .primo-accordion-icon,
    .primo-accordion-item.primo-open .primo-accordion-icon {
      background: rgba(255,90,95,.12);
      box-shadow: 0 0 0 2px rgba(255,90,95,.18) inset;
    }
    .primo-accordion-titles { display: flex; flex-direction: column; }
    .primo-accordion-title { font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 14.5px; color: #0F172A; }
    .primo-accordion-sub { font-family: 'IBM Plex Sans', sans-serif; font-size: 12px; color: #64748B; margin-top: 2px; }
    .primo-accordion-chevron { font-size: 13px; color: #64748B; transition: transform .25s ease, color .2s ease; flex: 0 0 auto; margin-left: 10px; }
    .primo-accordion-item.primo-open .primo-accordion-chevron { transform: rotate(180deg); color: #FF5A5F; }

    .primo-accordion-body { max-height: 0; overflow: hidden; transition: max-height .3s ease; }

    .primo-accordion-grid {
      display: grid; grid-template-columns: 1fr; gap: 16px;
      padding: 6px 18px 22px;
    }
    @media (min-width: 480px) { .primo-accordion-grid { grid-template-columns: repeat(2, 1fr); } }
    @media (min-width: 820px) { .primo-accordion-grid { grid-template-columns: repeat(3, 1fr); } }

    .primo-accordion-link {
      display: flex; flex-direction: column; align-items: center; gap: 16px;
      text-decoration: none !important; padding: 24px 20px; border-radius: 16px;
      background: #FFFFFF; border: 1px solid #E2E8F0;
      box-shadow: 0 4px 20px rgba(15,23,42,.03);
      transition: box-shadow .25s ease, transform .25s ease, border-color .2s ease;
    }
    .primo-accordion-link:hover {
      box-shadow: 0 20px 40px rgba(15,23,42,.08);
      transform: translateY(-4px);
      border-color: #FFC9C6;
    }
    .primo-accordion-link-icon {
      width: 64px; height: 64px; border-radius: 50%; background: #F8FAFC;
      display: flex; align-items: center; justify-content: center; font-size: 30px;
      box-shadow: 0 3px 10px rgba(15,23,42,.06);
      transition: background .2s ease, transform .2s ease;
    }
    .primo-accordion-link:hover .primo-accordion-link-icon {
      background: rgba(255,90,95,.14);
      transform: scale(1.06);
    }
    .primo-accordion-link-label {
      font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 16px;
      color: #0F172A; text-align: center; line-height: 1.3;
    }

    /* ====== TRUST BADGES ====== */
    #primo-value { background: #F8FAFC; padding: 12px 20px 52px; }
    .primo-value-grid { max-width: 1080px; margin: 0 auto; display: grid; grid-template-columns: repeat(3,1fr); gap: 28px; }
    @media (max-width: 820px) { .primo-value-grid { grid-template-columns: 1fr; max-width: 460px; } }
    .primo-value-item {
      background: #fff; border-radius: 14px; padding: 26px 22px; text-align: left;
      box-shadow: 0 4px 20px rgba(15,23,42,.05);
      transition: box-shadow .25s ease, transform .2s ease;
    }
    .primo-value-item:hover { box-shadow: 0 10px 34px rgba(15,23,42,.10); transform: translateY(-3px); }
    .primo-value-icon-circle {
      width: 50px; height: 50px; border-radius: 50%;
      background: linear-gradient(135deg, #FF5A5F, #FF8A8F);
      display: flex; align-items: center; justify-content: center;
      margin-bottom: 14px;
    }
    .primo-value-item svg { width: 24px; height: 24px; color: #fff; }
    .primo-value-item h3 { font-family: 'IBM Plex Sans', sans-serif; font-size: 16px; font-weight: 700; color: #0F172A; margin: 0 0 7px; }
    .primo-value-item p { font-family: 'IBM Plex Sans', sans-serif; font-size: 13.5px; line-height: 1.5; color: #64748B; margin: 0; }

    /* ====== GUÍAS: dos bloques (España / Alemania) ====== */
    #primo-guides { background: #fff; padding: 12px 20px 52px; }
    .primo-guides-inner { max-width: 1080px; margin: 0 auto; display: flex; flex-direction: column; gap: 40px; }
    .primo-guides-subtitle {
      font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 18px; color: #1A2E4A; margin: 0 0 18px;
    }
    .primo-guides-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
    @media (max-width: 860px) { .primo-guides-grid { grid-template-columns: repeat(2, 1fr); } }
    @media (max-width: 560px) { .primo-guides-grid { grid-template-columns: 1fr; } }
    .primo-guide-card {
      display: flex; flex-direction: column; background: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 14px;
      padding: 22px 20px; box-shadow: 0 2px 8px rgba(15,23,42,.04);
      transition: box-shadow .2s ease, transform .2s ease, border-color .2s ease;
    }
    .primo-guide-card:hover { box-shadow: 0 14px 32px rgba(15,23,42,.12); transform: translateY(-4px); border-color: #FFC9C6; }
    .primo-guide-title { font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 15px; color: #0F172A; line-height: 1.3; margin: 0 0 8px; }
    .primo-guide-excerpt { font-family: 'IBM Plex Sans', sans-serif; font-size: 13px; line-height: 1.5; color: #64748B; margin: 0 0 16px; flex: 1; }
    .primo-guide-link { font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 13.5px; color: #FF5A5F; text-decoration: none; }
    .primo-guide-link:hover { color: #E14549; }

    /* ====== BARRA "VOLVER" (guías / páginas legales) ====== */
    #primo-back-bar { padding: 14px 20px; background: #F8FAFC; }
    .primo-back-bar-inner { max-width: 980px; margin: 0 auto; }
    .primo-back-link {
      font-family: 'IBM Plex Sans', sans-serif; font-size: 13.5px; font-weight: 600; color: #64748B;
      text-decoration: none; transition: color .15s ease;
    }
    .primo-back-link:hover { color: #1A2E4A; }

    /* ====== TESTIMONIOS / LEAD MAGNET / LEGAL BAR — v25: 100% ancho, fuera del footer nativo ====== */
    #primo-testimonials, #primo-leadmagnet, #primo-legalbar {
      width: 100%;
      box-sizing: border-box;
    }
    #primo-testimonials { background: #F8FAFC; padding: 50px 20px 56px; border-top: 1px solid #E2E8F0; }
    #primo-testimonials .primo-test-title {
      text-align: center; font-family: 'IBM Plex Sans', sans-serif; font-weight: 800; font-size: 22px; color: #0F172A; margin: 0 0 30px;
    }
    .primo-test-grid { max-width: 1080px; margin: 0 auto; display: grid; grid-template-columns: repeat(3,1fr); gap: 22px; }
    @media (max-width: 860px) { .primo-test-grid { grid-template-columns: 1fr; max-width: 440px; } }
    .primo-test-card { background: #fff; border-radius: 14px; padding: 24px 22px; box-shadow: 0 4px 20px rgba(15,23,42,.05); border: 1px solid #E2E8F0; }
    .primo-test-head { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
    .primo-test-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; flex: 0 0 auto; background: #E2E8F0; }
    .primo-test-name { font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 14.5px; color: #0F172A; }
    .primo-test-stars { font-size: 12px; letter-spacing: 1px; margin-top: 2px; }
    .primo-test-quote { font-family: 'IBM Plex Sans', sans-serif; font-size: 13.5px; line-height: 1.55; color: #64748B; margin: 0; }

    /* ====== LEAD MAGNET ====== */
    #primo-leadmagnet { background: #0A192F; padding: 48px 20px; }
    .primo-lm-inner { max-width: 620px; margin: 0 auto; text-align: center; }
    .primo-lm-title { font-family: 'IBM Plex Sans', sans-serif; font-weight: 800; font-size: 24px; color: #fff; margin: 0 0 8px; }
    .primo-lm-sub { font-family: 'IBM Plex Sans', sans-serif; font-size: 14px; color: rgba(255,255,255,.75); line-height: 1.5; margin: 0 0 22px; }
    .primo-lm-form { display: flex; gap: 10px; flex-wrap: wrap; justify-content: center; }
    .primo-lm-form input[type="email"] {
      flex: 1 1 260px; min-width: 220px; padding: 13px 16px; border-radius: 8px; border: none;
      font-family: 'IBM Plex Sans', sans-serif; font-size: 14px; outline: none;
    }
    .primo-lm-form button {
      flex: 0 0 auto; background: #FF5A5F; color: #fff; border: none; border-radius: 8px; padding: 13px 22px;
      font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 14px; cursor: pointer;
      transition: background .15s ease, transform .15s ease;
    }
    .primo-lm-form button:hover { background: #E14549; transform: translateY(-1px); }
    .primo-lm-note { margin-top: 12px; font-size: 11.5px; color: rgba(255,255,255,.45); font-family: 'IBM Plex Sans', sans-serif; }

    form.subscribe-form, .gh-foot form, .site-footer form, .footer-form, .subscribe-form { display: none !important; }

    /* ====== v25: OCULTAR FOOTER NATIVO DE GHOST (ahora el footer propio va directo al body) ====== */
    footer.site-footer, .gh-foot { display: none !important; }

    /* ====== v25: OCULTAR BLOQUE NATIVO DE SUSCRIPCIÓN DEL TEMA SOURCE ====== */
    .gh-about, .gh-subscribe, .section-subscribe { display: none !important; }

    /* ====== COMPLIANCE LEGAL ====== */
    a[href*="ghost.org"] { display: none !important; }

    /* ====== MENÚ LEGAL + DISCLAIMER ====== */
    #primo-legalbar { background: #0A192F; padding: 22px 20px 26px; }
    .primo-legal-inner { max-width: 1080px; margin: 0 auto; text-align: center; }
    .primo-legal-links { display: flex; flex-wrap: wrap; justify-content: center; gap: 18px; margin-bottom: 12px; }
    .primo-legal-links a {
      font-family: 'IBM Plex Sans', sans-serif; font-size: 12px; color: rgba(255,255,255,.6); text-decoration: none;
      transition: color .15s ease;
    }
    .primo-legal-links a:hover { color: #fff; }
    .primo-affiliate-disclaimer {
      font-family: 'IBM Plex Sans', sans-serif; font-size: 11px; line-height: 1.5; color: rgba(255,255,255,.35); max-width: 560px; margin: 0 auto;
    }

    /* ====== TOAST ====== */
    #primo-country-toast {
      position: fixed; top: 18px; left: 50%; transform: translateX(-50%) translateY(-16px);
      background: #0A192F; color: #fff; z-index: 100000; max-width: 92vw;
      display: flex; align-items: center; gap: 16px; padding: 14px 16px 14px 20px;
      border-radius: 14px; box-shadow: 0 16px 34px rgba(15,23,42,.38);
      opacity: 0; pointer-events: none; transition: opacity .25s ease, transform .25s ease;
      font-family: 'IBM Plex Sans', sans-serif;
    }
    #primo-country-toast.primo-toast-visible { opacity: 1; transform: translateX(-50%) translateY(0); pointer-events: auto; }
    #primo-country-toast .primo-toast-msg { font-size: 13.5px; font-weight: 600; line-height: 1.35; white-space: nowrap; }
    #primo-country-toast .primo-toast-btns { display: flex; gap: 8px; flex: 0 0 auto; }
    #primo-country-toast button.primo-toast-country {
      border: none; cursor: pointer; border-radius: 20px; padding: 9px 14px; font-family: inherit; font-weight: 700; font-size: 13px;
      background: #fff; color: #0F172A; white-space: nowrap; transition: transform .15s ease, background .15s ease, color .15s ease;
    }
    #primo-country-toast button.primo-toast-country:hover { background: #FF5A5F; color: #fff; transform: translateY(-1px); }
    #primo-country-toast button.primo-toast-close {
      border: none; background: transparent; cursor: pointer; color: rgba(255,255,255,.55); font-size: 20px; line-height: 1; padding: 0 2px;
    }
    @media (max-width: 640px) {
      #primo-country-toast { flex-direction: column; align-items: stretch; text-align: center; gap: 10px; padding: 16px; }
      #primo-country-toast .primo-toast-msg { white-space: normal; }
      #primo-country-toast .primo-toast-btns { justify-content: center; }
    }

    /* ====== CEREBRO CENTRAL v27: POP-UP "VER DETALLES" ESTILO CHECK24 ====== */
    .primo-detail-panel {
      max-height: 0; overflow: hidden; opacity: 0;
      transition: max-height .35s ease, opacity .25s ease;
      margin: 0; box-sizing: border-box;
    }
    .primo-detail-panel.primo-detail-open { opacity: 1; margin: -14px 0 22px; }
    .primo-detail-inner {
      position: relative;
      background: #fff;
      border: 1px solid var(--line, #E2E8F0);
      border-top: 3px solid var(--sello, #FF5A5F);
      border-radius: 0 0 12px 12px;
      box-shadow: 0 18px 40px -18px rgba(15,23,42,.22);
      padding: 22px 24px 24px;
    }
    .primo-detail-close {
      position: absolute; top: 12px; right: 14px;
      width: 28px; height: 28px; border-radius: 50%; border: none;
      background: var(--paper-2, #F1ECE0); color: var(--ink, #0F172A);
      font-size: 16px; line-height: 1; cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      transition: background .15s ease;
    }
    .primo-detail-close:hover { background: var(--sello, #FF5A5F); color: #fff; }
    .primo-detail-grid {
      display: grid; grid-template-columns: 1fr; gap: 20px;
      font-family: 'IBM Plex Sans', sans-serif;
    }
    @media (min-width: 640px) { .primo-detail-grid { grid-template-columns: 1fr 1fr; } }
    .primo-detail-col h4 {
      font-family: 'IBM Plex Sans', sans-serif; font-size: 13px; font-weight: 700;
      text-transform: uppercase; letter-spacing: .04em; color: var(--ink, #0F172A);
      margin: 0 0 10px; padding-right: 26px;
    }
    .primo-detail-col ul { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
    .primo-detail-col li {
      font-size: 13px; line-height: 1.5; color: #4B5563;
      padding-left: 18px; position: relative;
    }
    .primo-detail-col li::before { content: '•'; position: absolute; left: 0; color: var(--piedra, #94A3B8); }
    .primo-detail-proscons { display: flex; flex-direction: column; gap: 18px; }
    .primo-detail-pros li, .primo-detail-contras li { padding-left: 22px; }
    .primo-detail-pros li::before {
      content: '✓'; position: absolute; left: 0; color: var(--verde, #16A34A); font-weight: 700;
    }
    .primo-detail-contras li::before {
      content: '✕'; position: absolute; left: 0; color: var(--sello, #DC2626); font-weight: 700;
    }
    .primo-detail-empty {
      font-size: 13px; color: #94A3B8; font-style: italic; margin: 0;
    }
    a.tarifa-link.primo-detail-trigger { cursor: pointer; user-select: none; }
    a.tarifa-link.primo-detail-trigger.primo-detail-trigger-open { color: var(--ink, #0F172A); font-weight: 700; }

    /* ====== LABOR ILLUSION ====== */
    #primo-loading-overlay {
      position: fixed; inset: 0; z-index: 2147483646;
      background: #F8FAFC;
      display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 18px;
      transition: opacity .4s ease;
      opacity: 1;
    }
    #primo-loading-overlay.primo-overlay-hide { opacity: 0; pointer-events: none; }
    .primo-spinner {
      width: 44px; height: 44px; border-radius: 50%;
      border: 4px solid rgba(255,90,95,.18); border-top-color: #FF5A5F;
      animation: primo-spin .75s linear infinite;
    }
    @keyframes primo-spin { to { transform: rotate(360deg); } }
    .primo-loading-text {
      font-family: 'IBM Plex Sans', sans-serif; font-size: 16px; font-weight: 700; color: #0F172A;
      text-align: center; padding: 0 24px; transition: opacity .15s ease;
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);



  const path = window.location.pathname;
  const isHome = (path === '/' || path === '');
  const isTagPage = path.indexOf('/tag/') === 0;
  const isGuidePage = Array.from(document.body.classList).some(cls => cls.startsWith('tag-guias'));
  // ===== v25: DETECCIÓN DE PÁGINAS LEGALES / INSTITUCIONALES =====
  const isLegalPage = path.includes('/aviso-legal') || path.includes('/politica-de') || path.includes('/sobre-nosotros');

  // ===== DETECCIÓN DE PAÍS =====
  let currentCountry = null;
  if (path.indexOf('espana') > -1) currentCountry = 'espana';
  else if (path.indexOf('alemania') > -1) currentCountry = 'alemania';
  else {
    try { currentCountry = localStorage.getItem('primo_country') || null; } catch (e) { currentCountry = null; }
  }
  if (currentCountry === 'espana' || currentCountry === 'alemania') {
    try { localStorage.setItem('primo_country', currentCountry); } catch (e) {}
  }

  function primoSetCountry(country) {
    currentCountry = country;
    try { localStorage.setItem('primo_country', country); } catch (e) {}
  }

  function primoResolveHref(link) {
    if (!link.requiresCountry) return link.url;
    if (currentCountry === 'espana') return link.urlEspana;
    if (currentCountry === 'alemania') return link.urlAlemania;
    return null;
  }

  const DEFAULT_HERO_SELECTORS = ['.gh-hero', '.site-hero', '.hero', 'form.subscribe-form', '.gh-content .site-description'];
  DEFAULT_HERO_SELECTORS.forEach(sel => document.querySelectorAll(sel).forEach(el => el.style.display = 'none'));

  // ===== DATOS DE LOS LINKS =====
  const LINKS = [
    { icon: "🔑", label: "Buscar Alquiler", phase: 1, requiresCountry: true, categoria: "Vivienda", urlEspana: "/mejor-plataforma-para-buscar-piso-en-espana/", urlAlemania: "/mejor-plataforma-para-buscar-piso-en-alemania/" },
    { icon: "🏥", label: "Seguro Médico", phase: 1, requiresCountry: true, categoria: "Salud", urlEspana: "/mejor-seguro-de-salud-para-recien-llegados-a-espana/", urlAlemania: "/mejor-seguro-de-salud-para-expats-en-alemania/" },
    { icon: "✈️", label: "Viajar Seguro", phase: 1, requiresCountry: false, categoria: "Seguro de Viaje", url: "/mejor-seguro-de-viaje-para-visitar-europa-desde-latam/" },
    { icon: "📄", label: "Armar tu CV", phase: 1, requiresCountry: false, categoria: "CV (ATS)", url: "/mejor-herramienta-para-crear-un-cv-europeo-ats-friendly/" },
    { icon: "📝", label: "Traducciones", phase: 1, requiresCountry: false, categoria: "Traducción Jurada", url: "/mejor-servicio-de-traduccion-jurada-oficial-en-europa/" },
    { icon: "📦", label: "Enviar Cajas", phase: 3, requiresCountry: false, categoria: "Enviar Paquetes", url: "/mejor-servicio-de-envio-de-paquetes-a-latam-desde-europa/" },
    { icon: "🏦", label: "Abrir Cuenta", phase: 2, requiresCountry: true, categoria: "Bancos", urlEspana: "/mejor-cuenta-bancaria-para-extranjeros-en-espana/", urlAlemania: "/mejor-cuenta-bancaria-para-extranjeros-en-alemania/" },
    { icon: "📱", label: "Tu Celular", phase: 2, requiresCountry: true, categoria: "Telefonía", urlEspana: "/mejor-operador-de-movil-para-expats-en-espana/", urlAlemania: "/mejor-operador-de-movil-para-expats-en-alemania/" },
    { icon: "💸", label: "Remesas a Casa", phase: 3, requiresCountry: false, categoria: "Enviar Dinero", url: "/mejor-app-para-enviar-dinero-a-latam-desde-europa/" },
    { icon: "📊", label: "Taxes e Impuestos", phase: 3, requiresCountry: true, categoria: "Impuestos", urlEspana: "/mejor-app-para-hacer-la-declaracion-de-la-renta-en-espana/", urlAlemania: "/mejor-app-para-hacer-la-declaracion-de-impuestos-en-alemania/" },
    { icon: "🎓", label: "Validar Títulos", phase: 1, requiresCountry: false, categoria: "Homologación", url: "/como-homologar-tu-titulo-universitario-en-europa/" },
    { icon: "🗣️", label: "Aprender Idioma", phase: 3, requiresCountry: true, categoria: "Idiomas", urlEspana: "/mejor-curso-de-ingles-y-frances-online-con-profesores-nativos/", urlAlemania: "/mejor-curso-de-aleman-online-con-certificado/" },
    { icon: "📺", label: "TV de tu País", phase: 3, requiresCountry: false, categoria: "VPN", url: "/mejor-vpn-para-ver-tv-y-bancos-de-latam-desde-europa/" },
    { icon: "💳", label: "Tarjetas Globales", phase: 3, requiresCountry: false, categoria: "Tarjetas", url: "/mejor-tarjeta-para-viajar-sin-comisiones-por-el-mundo/" }
  ];

  const PHASES = [
    { id: 1, icon: "🛫", title: "Antes de llegar", sub: "Prepara todo desde casa" },
    { id: 2, icon: "🏠", title: "Primera semana", sub: "Lo urgente al aterrizar" },
    { id: 3, icon: "🧾", title: "Ya instalado", sub: "Para el día a día" }
  ];

  // ===== GUÍAS: dataset con país =====
  const GUIDES = [
    { country: "espana", title: "Cómo conseguir el NIE y TIE en España", excerpt: "El trámite que bloquea todo lo demás: banco, móvil, alquiler. Te explicamos el camino más rápido.", url: "/como-conseguir-nie-espana/" },
    { country: "alemania", title: "Cómo hacer el Anmeldung en Alemania", excerpt: "Sin esto no existes en Alemania. Guía paso a paso para registrarte sin errores.", url: "/como-conseguir-anmeldung-alemania/" },
    { country: "espana", title: "El Empadronamiento en España", excerpt: "El papel que te abre la sanidad pública y el colegio de tus hijos. Cómo conseguirlo sin vueltas.", url: "/empadronamiento-espana/" },
    { country: "alemania", title: "Sobrevivir sin SCHUFA en Alemania", excerpt: "Sin historial crediticio, alquilar parece imposible. Estas son tus alternativas reales.", url: "/schufa-alemania/" },
    { country: "espana", title: "Alta en la Seguridad Social", excerpt: "Lo que necesitas antes de firmar tu primer contrato en España.", url: "/seguridad-social-espana/" },
    { country: "alemania", title: "Steuer-ID y tus impuestos", excerpt: "El número que te pedirán en cada trámite alemán. Qué es y cómo obtenerlo.", url: "/steuer-id-alemania/" }
  ];

  function primoBuildGuideCard(g) {
    return `
      <div class="primo-guide-card">
        <h3 class="primo-guide-title">${g.title}</h3>
        <p class="primo-guide-excerpt">${g.excerpt}</p>
        <a class="primo-guide-link" href="${g.url}">Leer guía →</a>
      </div>
    `;
  }

  function primoBuildGuidesSection() {
    const el = document.createElement('div'); el.id = 'primo-guides';
    const esCards = GUIDES.filter(g => g.country === 'espana').map(primoBuildGuideCard).join('');
    const deCards = GUIDES.filter(g => g.country === 'alemania').map(primoBuildGuideCard).join('');
    el.innerHTML = `
      <div class="primo-guides-inner">
        <div class="primo-guides-block">
          <h3 class="primo-guides-subtitle">🇪🇸 Trámites en España</h3>
          <div class="primo-guides-grid">${esCards}</div>
        </div>
        <div class="primo-guides-block">
          <h3 class="primo-guides-subtitle">🇩🇪 Trámites en Alemania</h3>
          <div class="primo-guides-grid">${deCards}</div>
        </div>
      </div>
    `;
    return el;
  }

  // ===== BARRA "VOLVER" (modo lectura guías / páginas legales) — v25: texto parametrizable =====
  function primoBuildBackBar(label, href) {
    const el = document.createElement('div'); el.id = 'primo-back-bar';
    const linkText = label || '← Volver al comparador';
    const linkHref = href || '/';
    el.innerHTML = '<div class="primo-back-bar-inner"><a href="' + linkHref + '" class="primo-back-link">' + linkText + '</a></div>';
    return el;
  }

  // ===== TOAST DE SELECCIÓN DE PAÍS =====
  let toastEl = null;
  function primoEnsureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.id = 'primo-country-toast';
    toastEl.innerHTML =
      '<span class="primo-toast-msg">Elige tu país para ver esta comparativa:</span>' +
      '<span class="primo-toast-btns">' +
        '<button type="button" class="primo-toast-country" data-country="espana">🇪🇸 España</button>' +
        '<button type="button" class="primo-toast-country" data-country="alemania">🇩🇪 Alemania</button>' +
      '</span>' +
      '<button type="button" class="primo-toast-close" aria-label="Cerrar">×</button>';
    document.body.appendChild(toastEl);

    toastEl.querySelector('.primo-toast-close').addEventListener('click', primoHideToast);
    toastEl.querySelectorAll('.primo-toast-country').forEach(btn => {
      btn.addEventListener('click', () => {
        const country = btn.getAttribute('data-country');
        primoSetCountry(country);
        if (typeof primoRefreshLinkHrefs === 'function') primoRefreshLinkHrefs();
        if (typeof primoUpdateSelectorState === 'function') primoUpdateSelectorState();
        const pending = toastEl.__pendingLink;
        primoHideToast();
        if (pending) {
          const href = country === 'espana' ? pending.urlEspana : pending.urlAlemania;
          window.location.href = href;
        }
      });
    });
    return toastEl;
  }
  let toastTimer = null;
  function primoShowCountryPrompt(link) {
    const t = primoEnsureToast();
    t.__pendingLink = link;
    t.classList.add('primo-toast-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(primoHideToast, 6000);
  }
  function primoHideToast() {
    if (!toastEl) return;
    toastEl.classList.remove('primo-toast-visible');
    clearTimeout(toastTimer);
  }

  let primoUpdateSelectorState, primoRefreshLinkHrefs;

  // ===== ACORDEÓN DE FASES =====
  function primoBuildAccordionSection() {
    const accordion = document.createElement('div'); accordion.className = 'primo-accordion';
    const linkElements = [];

    PHASES.forEach(phase => {
      const item = document.createElement('div'); item.className = 'primo-accordion-item';

      const head = document.createElement('div'); head.className = 'primo-accordion-head';
      head.innerHTML =
        '<span class="primo-accordion-title-wrap">' +
          '<span class="primo-accordion-icon">' + phase.icon + '</span>' +
          '<span class="primo-accordion-titles">' +
            '<span class="primo-accordion-title">' + phase.title + '</span>' +
            '<span class="primo-accordion-sub">' + phase.sub + '</span>' +
          '</span>' +
        '</span>' +
        '<span class="primo-accordion-chevron">▼</span>';

      const body = document.createElement('div'); body.className = 'primo-accordion-body';
      const grid = document.createElement('div'); grid.className = 'primo-accordion-grid';

      LINKS.filter(l => l.phase === phase.id).forEach(link => {
        const a = document.createElement('a');
        a.className = 'primo-accordion-link';
        const resolvedHref = primoResolveHref(link);
        a.href = resolvedHref || '#';
        a.innerHTML =
          '<span class="primo-accordion-link-icon">' + link.icon + '</span>' +
          '<span class="primo-accordion-link-label">' + link.label + '</span>';

        if (link.requiresCountry && !resolvedHref) {
          a.addEventListener('click', e => {
            e.preventDefault();
            primoShowCountryPrompt(link);
          });
        }

        linkElements.push({ el: a, link: link });
        grid.appendChild(a);
      });

      body.appendChild(grid);
      item.appendChild(head); item.appendChild(body);
      accordion.appendChild(item);

      head.addEventListener('click', () => {
        const isOpen = item.classList.contains('primo-open');
        accordion.querySelectorAll('.primo-accordion-item.primo-open').forEach(openItem => {
          if (openItem !== item) {
            openItem.classList.remove('primo-open');
            openItem.querySelector('.primo-accordion-body').style.maxHeight = null;
          }
        });
        if (isOpen) {
          item.classList.remove('primo-open');
          body.style.maxHeight = null;
        } else {
          item.classList.add('primo-open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    primoRefreshLinkHrefs = function () {
      linkElements.forEach(({ el, link }) => {
        const resolvedHref = primoResolveHref(link);
        el.href = resolvedHref || '#';
      });
      accordion.querySelectorAll('.primo-accordion-item.primo-open').forEach(openItem => {
        const body = openItem.querySelector('.primo-accordion-body');
        body.style.maxHeight = body.scrollHeight + 'px';
      });
    };

    return accordion;
  }

  // ===== INTERFAZ PRINCIPAL UNIFICADA =====
  function primoBuildMainInterface() {
    const wrap = document.createElement('div'); wrap.id = 'primo-main-interface';
    if (isHome) wrap.classList.add('primo-mi-overlap');

    const inner = document.createElement('div'); inner.className = 'primo-mi-inner';

    const timeline = document.createElement('div'); timeline.className = 'primo-mi-timeline';
    const STEP_LABELS = ['Elige tu país', 'Abre tu fase', 'Elige la opción top'];
    STEP_LABELS.forEach((label, idx) => {
      const item = document.createElement('div'); item.className = 'primo-mi-timeline-item';
      item.innerHTML = '<span class="primo-mi-number">' + (idx + 1) + '</span><span class="primo-mi-label">' + label + '</span>';
      timeline.appendChild(item);
    });

    const content = document.createElement('div'); content.className = 'primo-mi-content';

    // ===== BLOQUE DE MISIÓN (solo Home) — v22 =====
    let missionBlock = null;
    if (isHome) {
      missionBlock = document.createElement('div');
      missionBlock.className = 'primo-mission-block';
      missionBlock.innerHTML =
        '<h3>Nuestra misión: Hackear la burocracia europea.</h3>' +
        '<p>Agrupamos los únicos servicios (bancos, pisos, móviles) que aceptan a hispanos recién llegados sin exigir historial crediticio ni nóminas locales. Elige tu destino y sigue la ruta.</p>';
    }

    const countryGrid = document.createElement('div'); countryGrid.className = 'primo-country-card-grid';
    const cardES = document.createElement('button');
    cardES.type = 'button'; cardES.className = 'primo-country-card'; cardES.dataset.country = 'espana';
    cardES.innerHTML = '<span class="flag"><img class="flag-img" src="https://flagcdn.com/es.svg" alt="ES"></span><span class="primo-country-card-text">España</span>';
    const cardDE = document.createElement('button');
    cardDE.type = 'button'; cardDE.className = 'primo-country-card'; cardDE.dataset.country = 'alemania';
    cardDE.innerHTML = '<span class="flag"><img class="flag-img" src="https://flagcdn.com/de.svg" alt="DE"></span><span class="primo-country-card-text">Alemania</span>';
    countryGrid.appendChild(cardES); countryGrid.appendChild(cardDE);

    primoUpdateSelectorState = function () {
      [cardES, cardDE].forEach(btn => btn.classList.toggle('primo-active', btn.dataset.country === currentCountry));
    };
    primoUpdateSelectorState();

    [cardES, cardDE].forEach(btn => {
      btn.addEventListener('click', () => {
        primoSetCountry(btn.dataset.country);
        primoUpdateSelectorState();
        if (typeof primoRefreshLinkHrefs === 'function') primoRefreshLinkHrefs();
      });
    });

    const accordionSection = primoBuildAccordionSection();

    const hint = document.createElement('p'); hint.className = 'primo-mi-hint';
    hint.textContent = 'Al abrir una fase arriba verás las opciones ya comparadas para esa fase — sin letra pequeña, sin sorpresas.';

    if (missionBlock) content.appendChild(missionBlock);
    content.appendChild(countryGrid);
    content.appendChild(accordionSection);
    content.appendChild(hint);

    inner.appendChild(timeline);
    inner.appendChild(content);
    wrap.appendChild(inner);

    wrap.__accordionSection = accordionSection;
    return wrap;
  }

  // ===== TRUST BADGE PREMIUM JUNTO AL LOGO — v23 (reemplaza el tagline que se salía del header) =====
  function primoBuildTrustBadge() {
    const el = document.createElement('div');
    el.id = 'primo-trust-badge';
    el.className = 'primo-trust-badge';
    el.innerHTML =
      '<div class="ptb-number">#1</div>' +
      '<div class="ptb-text">' +
        '<span>El comparador</span>' +
        '<span class="ptb-highlight">para hispanos en Europa</span>' +
      '</div>';
    return el;
  }
  (function primoInsertTrustBadge() {
    const brandTarget = document.querySelector('.gh-head-brand');
    const badge = primoBuildTrustBadge();
    if (brandTarget) {
      brandTarget.insertAdjacentElement('afterend', badge);
    } else {
      // Fallback si el tema no expone .gh-head-brand
      const fallback = document.querySelector('.gh-head-logo') || document.querySelector('.gh-head-inner') || document.querySelector('header');
      if (fallback) fallback.insertAdjacentElement('afterend', badge);
    }
  })();

  // ===== COLLAGE DE BANDERAS EN EL HEADER: inyectado en body, a prueba de overflow — v23 ====== 
  function primoBuildHeaderFlagCollage() {
    const el = document.createElement('div');
    el.id = 'primo-header-flags';
    el.setAttribute('aria-hidden', 'true');
    const countryCodes = ['mx', 'co', 'ar', 'es', 'pe', 've', 'cl', 'ec', 'gt', 'cu'];
    el.innerHTML = countryCodes
      .map(code => '<img class="header-flag-img" src="https://flagcdn.com/' + code + '.svg" alt="flag">')
      .join('');
    return el;
  }
  (function primoInsertHeaderFlagCollage() {
    // v23: .gh-head necesita conservar su overflow:hidden !important para
    // recortar el watermark de banderas de fondo (si no, riesgo de scroll
    // horizontal en móvil). Por eso, en vez de tocar ese overflow, el
    // collage se inyecta directamente en document.body con position:fixed,
    // escapando por completo de cualquier overflow/stacking context del
    // tema de Ghost. Su posición vertical se recalcula con
    // getBoundingClientRect() del header, así queda siempre centrado sobre
    // la cabecera tanto en Home como en el resto de páginas.
    const headerTarget = document.querySelector('.gh-head') || document.querySelector('header.site-header') || document.querySelector('header');
    if (!headerTarget) return;
    const collage = primoBuildHeaderFlagCollage();
    document.body.appendChild(collage);

    function primoPositionHeaderFlags() {
      const rect = headerTarget.getBoundingClientRect();
      collage.style.top = (rect.top + rect.height / 2) + 'px';
    }
    primoPositionHeaderFlags();
    window.addEventListener('resize', primoPositionHeaderFlags);
    window.addEventListener('scroll', primoPositionHeaderFlags, { passive: true });
    // v26: recalcula tras la carga completa (fuentes/imágenes) por si el alto
    // del header varía levemente entre el primer paint y el load final.
    window.addEventListener('load', primoPositionHeaderFlags);
  })();

  const mainInterface = isLegalPage ? null : primoBuildMainInterface();

  // ===== CONTADOR DE IMPACTO =====
  function primoBuildImpactCounter() {
    const el = document.createElement('div'); el.id = 'primo-impact';
    el.innerHTML = `
      <div class="primo-impact-inner">
        <span class="primo-impact-icon">👥</span>
        <span class="primo-impact-text">Más de <b>+500 hispanos</b> ya han asegurado su vida en Europa sin burocracia.</span>
      </div>
    `;
    return el;
  }

  // ===== HERO + TRUST SIGNALS + GUÍAS (solo Home) =====
  let hero = null, valueSection = null, impactCounter = null, guidesSection = null;
  if (isHome) {
    hero = document.createElement('div'); hero.id = 'primo-hero';
    hero.innerHTML = `
      <div class="primo-hero-inner">
        <h1>El sistema europeo es un laberinto burocrático.<em>Nosotros te damos el atajo directo.</em></h1>
        <p class="primo-sub">Te piden nómina para alquilar y cuenta bancaria para el móvil, pero no te dan cuenta sin alquiler. Rompe el bucle: descubre las plataformas verificadas y 100% legales que puedes contratar según tu situación.</p>
      </div>
    `;

    impactCounter = primoBuildImpactCounter();

    valueSection = document.createElement('div'); valueSection.id = 'primo-value';
    valueSection.innerHTML = `
      <div class="primo-value-grid">
        <div class="primo-value-item">
          <div class="primo-value-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 3h9l3 3v15H6z"/><path d="M5 20L20 5" stroke="#fff" stroke-width="2"/></svg>
          </div>
          <h3>Cero Burocracia</h3>
          <p>Alternativas flexibles que no te exigen papeleo interminable.</p>
        </div>
        <div class="primo-value-item">
          <div class="primo-value-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4A8.7 8.7 0 0 1 6 18l-3 1 1-3a8.4 8.4 0 0 1-1-4A8.4 8.4 0 0 1 12 3.5a8.4 8.4 0 0 1 9 8z"/></svg>
          </div>
          <h3>100% en tu idioma</h3>
          <p>Plataformas y servicios con soporte en español para tu tranquilidad.</p>
        </div>
        <div class="primo-value-item">
          <div class="primo-value-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l7 3v6c0 5-3 8.5-7 9-4-.5-7-4-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>
          </div>
          <h3>Seguridad y Ahorro</h3>
          <p>Opciones verificadas para evitar comisiones ocultas y sobrecostes innecesarios.</p>
        </div>
      </div>
    `;

    guidesSection = primoBuildGuidesSection();
  }

  // ===== INSERTAR EN EL DOM =====
  // Home:        Header -> Hero -> Interfaz unificada -> Impact counter -> Trust Badges -> Guías
  // Guía (post): Header -> Barra "Volver al comparador"  (NO se inyecta el comparador)
  // Legal (v25): Header -> Barra "Volver a la página principal"  (NO se inyecta el comparador)
  // Resto:       Header -> Interfaz unificada
  const anchor = document.querySelector('.gh-head') || document.querySelector('header');
  let backBar = null;
  if (anchor) {
    let sequence;
    if (isHome) {
      sequence = [hero, mainInterface, impactCounter, valueSection, guidesSection];
    } else if (isGuidePage) {
      backBar = primoBuildBackBar('← Volver al comparador', '/');
      sequence = [backBar];
    } else if (isLegalPage) {
      // v25: en páginas legales SOLO va la back bar, nunca el comparador
      backBar = primoBuildBackBar('← Volver a la página principal', '/');
      sequence = [backBar];
    } else {
      sequence = [mainInterface];
    }
    let insertPoint = anchor;
    sequence.forEach(el => {
      if (!el) return;
      insertPoint.insertAdjacentElement('afterend', el);
      insertPoint = el;
    });
  }


  // ===== LEAD MAGNET =====
  function primoBuildLeadMagnet() {
    const el = document.createElement('div'); el.id = 'primo-leadmagnet';
    el.innerHTML = `
      <div class="primo-lm-inner">
        <h2 class="primo-lm-title">Evita perder dinero al emigrar.</h2>
        <p class="primo-lm-sub">Descarga gratis el Checklist: 5 errores fatales al alquilar y abrir cuentas en España/Alemania.</p>
        <form class="primo-lm-form" action="#" method="POST">
          <input type="email" name="email" placeholder="Tu email" required>
          <button type="submit">Quiero la guía gratis</button>
        </form>
        <p class="primo-lm-note">Sin spam. Solo la guía y contenido útil para tu mudanza.</p>
      </div>
    `;
    return el;
  }

  // ===== BARRA LEGAL =====
  function primoBuildLegalBar() {
    const el = document.createElement('div'); el.id = 'primo-legalbar';
    el.innerHTML = `
      <div class="primo-legal-inner">
        <div class="primo-legal-links">
          <a href="/sobre-nosotros/">Sobre nosotros</a>
          <a href="/aviso-legal-impressum/">Aviso Legal</a>
          <a href="/politica-de-privacidad/">Política de Privacidad</a>
          <a href="/politica-de-cookies/">Política de Cookies</a>
        </div>
        <p class="primo-affiliate-disclaimer">Los servicios se contratan directamente con proveedores independientes. Primo Europa puede recibir una comisión si utilizas algunos enlaces, sin coste adicional para ti.</p>
      </div>
    `;
    return el;
  }

  // ===== v25: FOOTER PROPIO SIEMPRE AL FINAL ABSOLUTO DEL DOM (document.body.appendChild) =====
  // Ya no se inyecta relativo al footer nativo (.gh-foot / footer.site-footer),
  // que quedaba encajonado por el ancho del contenedor del tema. El footer
  // nativo se oculta por CSS (footer.site-footer, .gh-foot { display:none !important; })
  // y estos dos bloques se anclan directamente al <body>, a ancho completo.
  (function primoInsertOwnFooter() {
    const leadMagnet = primoBuildLeadMagnet();
    const legalBar = primoBuildLegalBar();
    document.body.appendChild(leadMagnet);
    document.body.appendChild(legalBar);
  })();

  // ===== LABOR ILLUSION — desactivado en guías y en páginas legales (v25) =====
  const isArticlePage = !isHome && !isTagPage;
  if (isArticlePage && !isGuidePage && !isLegalPage) {
    const overlay = document.createElement('div');
    overlay.id = 'primo-loading-overlay';
    overlay.innerHTML =
      '<div class="primo-spinner"></div>' +
      '<p class="primo-loading-text" id="primoLoadingText">Analizando proveedores...</p>';
    document.body.appendChild(overlay);

    // Carga cerrada: el usuario solo ve una pantalla completa hasta que el comparador está listo.
    const loadingTextEl = overlay.querySelector('#primoLoadingText');
    const primoLoadingSteps = [
      { delay: 1500, text: "Filtrando opciones sin papeleo local..." },
      { delay: 3300, text: "¡Mejores resultados listos!" }
    ];
    primoLoadingSteps.forEach(step => {
      setTimeout(() => { loadingTextEl.textContent = step.text; }, step.delay);
    });

    function primoFocusComparatorBeforeReveal() {
      if (window.location.hash !== '#primo-comparador') return;
      const target = document.querySelector('.primo-custom-layout .top') || document.querySelector('.primo-custom-layout');
      if (!target) return;
      const header = document.querySelector('.gh-head, header');
      const offset = header ? header.getBoundingClientRect().height : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    }

    // Última comprobación de posición justo antes de enseñar la página.
    setTimeout(primoFocusComparatorBeforeReveal, 4800);
    setTimeout(() => overlay.classList.add('primo-overlay-hide'), 5000);
    setTimeout(() => overlay.remove(), 5450);
  }


  document.addEventListener('DOMContentLoaded', function() {
    const signInBtns = document.querySelectorAll('[data-portal="signin"]');
    signInBtns.forEach(btn => { btn.textContent = 'Entrar'; });

    const signUpBtns = document.querySelectorAll('[data-portal="signup"]');
    signUpBtns.forEach(btn => { btn.textContent = 'Únete gratis'; });
  });
})();
